import { mq } from "../../cssInJs";

export default {
  container: mq({
    cursor: "pointer",
    zIndex: "1000",
    position: "absolute",
    padding: "0",
    top: ["0px", null, "16px"],
    right: ["35px", null, "90px"],
    //border: '1px solid red'
  }),
  countContainer: mq({
    width: ["50px", null, "50px"],
    height: ["50px", null, "50px"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "svg": mq({
      width: ["60%"],
      height: ["90%"],
      color: "#3b3b3b",
    }),
  }),
  count: mq({
    position: "absolute",
    backgroundColor: "#3b3b3b",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "0rem 0.2rem",
    lineHeight: "1",
    top: ["3px", null, "0px"],
    right: "5px",
    //left : ['1.5rem', null, '2rem']
  }),
};
